import React, { Component } from "react";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import LocationSidebar from "../components/LocationSidebar";

const bg = require("../../../../images/servicehero.png");

class CommercialCleaningBrisbane extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Commercial Cleaning Brisbane | Office & Business Cleaning"
          description="Professional commercial cleaning Brisbane for offices, restaurants and retail spaces. Reliable cleaning services."
          keywords="commercial cleaning brisbane, office cleaning brisbane, business cleaning brisbane, corporate cleaning brisbane, retail cleaning brisbane, restaurant cleaning brisbane, warehouse cleaning brisbane, industrial cleaning brisbane, strata cleaning brisbane, body corporate cleaning brisbane, medical cleaning brisbane, professional commercial cleaners brisbane, affordable commercial cleaning brisbane, contract cleaning brisbane, office sanitisation brisbane, hospitality cleaning brisbane, commercial kitchen cleaning brisbane, builders cleaning brisbane, post construction cleaning brisbane, after renovation cleaning brisbane, daily office cleaning brisbane, weekly commercial cleaning brisbane, reliable commercial cleaners brisbane, professional business cleaners brisbane, carpet cleaning brisbane office, window cleaning brisbane commercial, deep office cleaning brisbane, cleaning company brisbane, commercial cleaners near me brisbane, office maintenance cleaning brisbane"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Commercial Cleaning Services Brisbane
                </h1>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <LocationSidebar activePage="/commercial-cleaning-brisbane/" />
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Commercial Cleaning Services Brisbane
                          </h4>
                          <p>
                            A clean workplace enhances productivity and creates
                            a positive impression for clients. Our commercial
                            cleaning Brisbane service provides tailored cleaning
                            solutions for businesses of all sizes.
                          </p>

                          <h4 className="dlab-title m-t30">
                            Office Cleaning Brisbane
                          </h4>
                          <p>Our office cleaning services include:</p>
                          <ul className="list-check primary">
                            <li>Workstation cleaning</li>
                            <li>Carpet vacuuming</li>
                            <li>Floor mopping</li>
                            <li>Restroom sanitisation</li>
                            <li>Waste removal</li>
                          </ul>

                          <h4 className="dlab-title m-t30">
                            Restaurant and Retail Cleaning
                          </h4>
                          <p>
                            We ensure hospitality and retail spaces remain
                            hygienic and presentable. Our team is trained to
                            handle the specific requirements of commercial
                            kitchens and high-traffic retail environments.
                          </p>

                          <h4 className="dlab-title m-t30">
                            Why Choose Our Commercial Cleaners
                          </h4>
                          <ul className="list-check primary">
                            <li>Flexible cleaning schedules</li>
                            <li>Experienced team</li>
                            <li>Reliable and punctual service</li>
                            <li>Comprehensive insurance coverage</li>
                          </ul>

                          <p className="m-t30">
                            Contact us for commercial cleaning Brisbane today.
                            Our team is ready to provide a clean and safe
                            working environment for your business.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default CommercialCleaningBrisbane;
